import { useTranslation } from 'react-i18next'
import { getBooleanDisplayValue } from '../../../../util/StringUtil'

export default function useKioskDropdownOptions({ languages }) {
  const { t } = useTranslation()

  const dropdownOptions = (fieldKey) => {
    switch (fieldKey) {
      case 'locationType':
        return [
          {
            value: 'TEMPLE',
            label: t('temple.kiosk.locationType.TEMPLE', 'Temple'),
          },
          {
            value: 'FAMILY_HISTORY_CENTER',
            label: t('temple.kiosk.locationType.FAMILY_HISTORY_CENTER', 'Family History Center'),
          },
          {
            value: 'PATRON_HOUSING',
            label: t('temple.kiosk.locationType.PATRON_HOUSING', 'Patron Housing'),
          },
          {
            value: 'OTHER',
            label: t('temple.kiosk.locationType.OTHER', 'Other'),
          },
        ]
      case 'langCode':
        return languages?.map((lang) => {
          return {
            value: lang.code,
            label: `${lang.code} - ${lang.name}`,
          }
        })
      case 'authorized':
        return [
          {
            value: 'true',
            label: getBooleanDisplayValue(true),
          },
          {
            value: 'false',
            label: getBooleanDisplayValue(false),
          },
        ]
      case 'authorizedFilter':
        return [
          {
            value: 'null',
            label: t('temple.kiosk.filter.all', 'All'),
          },
          {
            value: 'true',
            label: t('temple.kiosk.filter.authorizedOnly', 'Authorized Only'),
          },
          {
            value: 'false',
            label: t('temple.kiosk.filter.unauthorizedOnly', 'Unauthorized Only'),
          },
        ]
      default:
        return []
    }
  }

  return { dropdownOptions }
}
